import { render, staticRenderFns } from "./formTiktok.vue?vue&type=template&id=89f086b8&"
import script from "./formTiktok.vue?vue&type=script&lang=js&"
export * from "./formTiktok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports